import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => (
  <div
    data-testid="services-marquee"
    className="relative overflow-hidden border-y border-gold/10 bg-navy-900/70 py-5"
    aria-hidden="true"
  >
    <div className="marquee-track">
      {[0, 1].map((half) => (
        <div key={half} className="flex shrink-0 items-center">
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${half}-${item}`} className="flex items-center">
              <span className="px-8 font-mono text-xs sm:text-sm uppercase tracking-[0.3em] text-slate-400">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
